import React, { useState } from 'react';
import { ClarifySpec, buildClarifyAnswer, questionKey } from '../../utils/parseClarifyBlock';

interface Props {
  spec: ClarifySpec;
  disabled?: boolean;
  onSubmit: (text: string) => void;
}

const ClarifyQuestions: React.FC<Props> = ({ spec, disabled, onSubmit }) => {
  const [selections, setSelections] = useState<Record<string, string[]>>({});
  const autoSend = spec.questions.length === 1 && !spec.questions[0].multi;

  const choose = (qKey: string, label: string, multi: boolean) => {
    if (disabled) return;
    if (autoSend) { onSubmit(label); return; }
    setSelections((prev) => {
      const cur = prev[qKey] ?? [];
      if (multi) {
        const next = cur.includes(label) ? cur.filter((l) => l !== label) : [...cur, label];
        return { ...prev, [qKey]: next };
      }
      return { ...prev, [qKey]: [label] };
    });
  };

  const anyAnswered = Object.values(selections).some((l) => l.length > 0);

  return (
    <div className="mt-3 space-y-3" dir="rtl">
      {spec.questions.map((q, i) => {
        const qKey = questionKey(q, i);
        const sel = selections[qKey] ?? [];
        return (
          <div key={qKey}>
            <p className="text-sm font-medium text-gray-700 mb-1.5">{q.text}</p>
            <div className="flex flex-wrap gap-2">
              {q.options.map((o) => {
                const active = sel.includes(o.label);
                return (
                  <button
                    key={o.label}
                    type="button"
                    disabled={disabled}
                    aria-pressed={active}
                    onClick={() => choose(qKey, o.label, !!q.multi)}
                    className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
                      active
                        ? 'bg-primary-50 border-primary-400 text-primary-700'
                        : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300'
                    } ${disabled ? 'opacity-60 cursor-default' : ''}`}
                  >
                    {o.label}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
      {!autoSend && !disabled && (
        <button
          type="button"
          disabled={!anyAnswered}
          onClick={() => onSubmit(buildClarifyAnswer(spec.questions, selections))}
          className="px-4 py-1.5 rounded-lg text-sm bg-primary-600 text-white disabled:opacity-50 hover:bg-primary-700 transition-colors"
        >
          שלח תשובות
        </button>
      )}
    </div>
  );
};

export default ClarifyQuestions;
